/**
 * Remark plugin: detects GitHub-style callouts in blockquotes ([!info]-, [!info]+, etc.)
 * and adds hProperties to the node so the React renderer can show them as <details>/<summary>.
 * Runs on the mdast (markdown AST) before conversion to hast.
 */
const calloutRegex = /^\s*\[!(\w+)\]([+-]?)[ \t]*([^\n]*)/;

function getFirstLineText(node) {
    if (!node || !node.children || node.children.length === 0) return '';
    const first = node.children[0];
    if (first.type === 'paragraph' && first.children) {
        return first.children
            .filter(c => c.type === 'text' && c.value)
            .map(c => c.value)
            .join('')
            .split('\n')[0];
    }
    return '';
}

export default function remarkCalloutBlockquote() {
    return (tree) => {
        if (!tree.children) return;
        for (let i = 0; i < tree.children.length; i++) {
            const node = tree.children[i];
            if (node.type !== 'blockquote' || !node.children || node.children.length === 0) continue;
            const firstLine = getFirstLineText(node);
            const match = calloutRegex.exec(firstLine);
            if (!match) continue;
            const type = match[1];
            const defaultOpen = match[2] === '+';
            const collapsible = match[2] === '-' || match[2] === '+';
            const title = (match[3] || type).trim();
            node.data = node.data || {};
            node.data.hProperties = {
                ...(node.data.hProperties || {}),
                'data-callout-type': type,
                'data-callout-open': String(defaultOpen),
                'data-callout-title': title,
                'data-callout-collapsible': String(collapsible),
            };
            // Remove the first paragraph (the title line) so only the body is rendered inside the callout
            node.children = node.children.slice(1);
            // Merge following blockquotes that are not callouts (content split by blank lines in MD)
            while (i + 1 < tree.children.length) {
                const next = tree.children[i + 1];
                if (next.type !== 'blockquote' || !next.children || next.children.length === 0) break;
                const nextFirst = getFirstLineText(next);
                if (calloutRegex.test(nextFirst)) break;
                node.children = node.children.concat(next.children);
                tree.children.splice(i + 1, 1);
            }
        }
    };
}
